// Centralized mock / fallback data for the React app.
// All mock values are marked clearly so they can be replaced with real API
// responses without touching screens.

// MOCK: voice practice prompts (used until real lesson API delivers prompts)
export const VOICE_PROMPTS = [
  { en: "Hello, my name is Aarav.", hi: "Namaste, mera naam Aarav hai." },
  { en: "I am going to school.", hi: "Main school ja raha hoon." },
  { en: "Two plus three equals five.", hi: "Do jama teen barabar paanch." },
];

// MOCK: emotional re-entry / engagement copy (Mashy missed you)
export const ENGAGEMENT_COPY = {
  welcomeBack: [
    "Mashy missed you! Aaja, ek chhota lesson karte hain.",
    "Welcome back! Your streak is waiting for you.",
    "Mashy ko aapki yaad aa rahi thi! Ready to learn?",
  ],
  milestone: [
    "Milestone unlocked! You are unstoppable 🏆",
    "100 XP done — Mashy is doing a somersault!",
  ],
  dailyChallenge: [
    "Today's challenge: 2 lessons in 10 minutes!",
    "Quick win: 5 math questions and 1 voice line.",
  ],
};

// MOCK: badge placeholders (real badges will come from backend later)
export const BADGE_PLACEHOLDERS = [
  { id: "first-lesson", label: "First Lesson", icon: "🎯", unlocked: true },
  { id: "3-day-streak", label: "3-Day Streak", icon: "🔥", unlocked: true },
  { id: "math-rookie", label: "Math Rookie", icon: "🧮", unlocked: false },
  { id: "voice-hero", label: "Voice Hero", icon: "🎙️", unlocked: false },
];

export const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
